// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"styles_buttonWrapper__oJzNy"};